export const statusRegType = [
  { id: 0, title: "Pending", className: "pending" },
  { id: 1, title: "Submitted", className: "inprogress" },
  { id: 2, title: "Accepted", className: "Accepted" },
  { id: 3, title: "SA Reverted", className: "inprogress" },
  { id: 4, title: "Rejected", className: "rejected" },
  { id: 5, title: "Reverted", className: "inprogress" },
  { id: 6, title: "Agreement Execution", className: "agrementexecution" },
  { id: 7, title: "Ongoing Project", className: "Accepted" },
];
export const statusVendorType = [
  { id: 0, title: "Pending", className: "pending" },
  { id: 1, title: "Submitted", className: "inprogress" },
  { id: 2, title: "Initial Acceptance", className: "agrementexecution" },
  { id: 3, title: "Payment Initiated", className: "inprogress" },
  { id: 4, title: "Payment Confirmed", className: "accepted" },
  { id: 5, title: "Approved", className: "accepted" },
  { id: 6, title: "SA Reverted", className: "acceptance2" },
  { id: 7, title: "Reverted to User", className: "acceptance2" },
  { id: 8, title: "Payment Issue", className: "pending" },
];
export const createdFromAdmin = [
  { id: 99, title: "All", className: "Accepted" },
  { id: 0, title: "User", className: "pending" },
  { id: 1, title: "Admin", className: "inprogress" },
];
